import {
  useEffect,
  useState,
} from "react";

import { useParams } from "react-router-dom";

import Api from "../../../shared/api/api";

import "../styles/Blog.css";

export default function Blog() {
  const { title } = useParams();

  const [blog, setBlog] =
    useState(null);

  const [isLoading, setIsLoading] =
    useState(true);

  const [error, setError] =
    useState("");

  /* -----------------------------------------
     Date Formatting
  ------------------------------------------ */

  const formatDate = (dateString) => {
    if (!dateString) {
      return "";
    }

    const safeString =
      String(dateString).replace(
        /-/g,
        "/"
      );

    const date = new Date(safeString);

    if (Number.isNaN(date.getTime())) {
      return dateString;
    }

    const month = String(
      date.getMonth() + 1
    ).padStart(2, "0");

    const day = String(
      date.getDate()
    ).padStart(2, "0");

    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  };

  /* -----------------------------------------
     Load Blog
  ------------------------------------------ */

  useEffect(() => {
    let isMounted = true;

    const fetchBlog = async () => {
      setIsLoading(true);
      setError("");

      try {
        const decodedTitle =
          decodeURIComponent(title || "");

        const response =
          await Api.getByTitleOrUsername(
            "blog",
            decodedTitle
          );

        const blogData =
          response?.blog || response;

        if (!blogData) {
          throw new Error(
            "Blog not found."
          );
        }

        if (isMounted) {
          setBlog(blogData);
        }
      } catch (requestError) {
        console.error(
          "Error loading blog:",
          requestError
        );

        if (isMounted) {
          setError(
            requestError?.message ||
              "The blog could not be loaded."
          );

          setBlog(null);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchBlog();

    return () => {
      isMounted = false;
    };
  }, [title]);

  /* -----------------------------------------
     Loading and Error States
  ------------------------------------------ */

  if (isLoading) {
    return (
      <main className="blogContainer">
        <p
          className="blogLoading"
          role="status"
        >
          Loading...
        </p>
      </main>
    );
  }

  if (error || !blog) {
    return (
      <main className="blogContainer">
        <div
          className="warningError"
          role="alert"
        >
          {error ||
            "The blog could not be found."}
        </div>
      </main>
    );
  }

  /* -----------------------------------------
     Blog Image
  ------------------------------------------ */

  const imageSrc = blog.image
    ? blog.image.includes("?")
      ? `${blog.image}&raw=1`
      : `${blog.image}?raw=1`
    : "https://via.placeholder.com/400x400?text=No+Image";

  /* -----------------------------------------
     Render
  ------------------------------------------ */

  return (
    <main className="blogContainer">
      <article className="blogContentWrapper">
        <div className="blogLeft">
          <img
            src={imageSrc}
            alt={blog.title || "Blog image"}
            className="blogImage"
          />
        </div>

        <div className="blogRight">
          <h1 className="blogTitle">
            {blog.title}
          </h1>

          <p className="blogDate">
            {formatDate(blog.date)}
          </p>

          <div
            className="blogHtmlContent"
            dangerouslySetInnerHTML={{
              __html:
                blog.content || "",
            }}
          />
        </div>
      </article>
    </main>
  );
}